import { Injector } from '@angular/core';
import { Store } from '@sama/app-state';
import { ShapeLocationState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-location-state';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { selectionToArray } from '../../../../cross-team-shared/misc-utils';
import { getShapeHelper } from '../../shape-helpers/get-shape-helper';
import { AbstractVectorTranslationHelper } from '../shared/drag-handlers/abstract-vector-translation-helper';

export class ShapeTranslationHelper extends AbstractVectorTranslationHelper {
  protected method = 'drag_shape';

  constructor(
    injector: Injector,
    private options?: {
      clickedShapeStore?: Store<ShapeState2D>;
      shapeStoreToMove?: Store<ShapeState2D>;
    },
  ) {
    super(injector);
  }

  override getCandidateShapeStores() {
    if (this.options?.clickedShapeStore && !this.isClickedShapeSelected()) {
      return [this.options.clickedShapeStore];
    }
    if (this.options?.shapeStoreToMove) {
      return [this.options.shapeStoreToMove];
    } else {
      return super.getCandidateShapeStores();
    }
  }

  protected getMovableSubpointIndexes(
    shapeStore: Store<ShapeState2D>,
    location: ShapeLocationState2D,
  ) {
    const shapeHelper = getShapeHelper(shapeStore.state().type);
    const subpointIndexes = location.points.map((_, i) => i);
    return subpointIndexes.filter((i) =>
      shapeHelper.doesSubpointMoveWithShape(i),
    );
  }

  private isClickedShapeSelected() {
    return selectionToArray(this.store.state().selection).includes(
      this.options!.clickedShapeStore!.state().index,
    );
  }
}
